import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ISession } from '../../../models/session';
import { environment } from '../../../../environments/environment';
import { SessionsService } from '../sessions.service';
import { first, map, tap } from 'rxjs/operators';
import { PluginsService } from '../../plugins/plugins.service';
import { PreviewService, SESSION_NAME_PREFIX } from '../../preview/preview.service';
import { intersection, groupBy, endsWith, contains, flatten, find, propEq } from 'ramda/es';

@Component({
  selector: 'session-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss']
})
export class SessionsLinksComponent implements OnInit {

  @Input() group: 'wall' | undefined;
  public config = environment;
  public session: ISession;
  public links = {};
  public linksCategories = [];
  public moderatorUrl = '';

  constructor(
    private router: Router,
    private sessionsService: SessionsService,
    private route: ActivatedRoute,
    private pluginsService: PluginsService,
    private previewService: PreviewService
  ) {}

  public shouldKeepCategory(category, sessionType) {
    if (category === 'other') {
      // was not removed from ngOnInit, we might want it in the future
      return false;
    }
    if (sessionType === 'video') {
      return !endsWith('wall', category) && !endsWith('webapp', category);
    }
    if (sessionType === 'interactive') {
      return !endsWith('common', category);
    }
    return true;
  }

  ngOnInit() {
    const parentData$ = this.route.parent.data;

    parentData$
      .pipe(
        first(),
        map(route => route.data),
        tap((session: ISession) => {
          this.session = session;
          const other = 'other';
          const keys = Object.keys(this.config.sessions.links);
          const orderedLinks = keys.reduce(
            (links, type) => (links[type] = this.config.sessions.links[type]),
            {}
          );
          this.links = groupBy(
            (link: any) =>
              (
                orderedLinks.find(f => f.values.find(value => value === link.name)) || {
                  name: other
                }
              ).name
          )(session.urls);
          this.linksCategories = Object.keys(this.links)
            .sort(name => (name === other ? 1 : -1))
            .filter(category => this.shouldKeepCategory(category, this.session.types.sessionType));
        })
      )
      .subscribe(res => {
        // Here, we are filtering all links to get only used links (based on plugins activation)
        const categoriesTypes = ['wall', 'webapp'];
        this.pluginsService.getAll(this.session).subscribe(plugins => {
          const names = flatten(
            categoriesTypes.map(type => {
              return this.previewService
                .getLinks(type, this.session, plugins)
                .map(link => link.name.replace(`${SESSION_NAME_PREFIX}.`, ''));
            })
          );
          categoriesTypes.forEach(wallName => {
            const type = `${SESSION_NAME_PREFIX}.${wallName}`;
            this.links[type] = this.links[type].filter(link => contains(link.name, names));
          });
          this.moderatorUrl = find(
            propEq('name', 'moderator'),
            this.links['sessions.details.links.general']
          ).link;
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/links/links.component.ts